module.exports = "img/3.0e8183.webp";